import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_86: FaireProductEntity = {
  token: "starter_collection_86",
  type: "product",
  name: "Oat Napkins Set",
  brandName: "Hedley & Bennett",
  imageUrl:
    '"https://cdn.faire.com/fastly/cfe9533ad2cb1aa1037a209e0b17387bfab08ea3fae45b1d96d7eb9eb280f64c.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=3657',
  priceDollars: 32,
  msrpDollars: 64,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
